module.exports = __webpack_public_path__ + "img/200114.e489808a.png";